import { startsWith } from "lodash/fp";

import { STARRED_TRANSCRIPT_ENTRY_PREFIX } from "@readai/common/constants/transcript";

const CROSSTALK = "CROSSTALK";
export const UNKNOWN_SPEAKER = "UNKNOWN_SPEAKER";

const INVALID_SPEAKER_NAMES = new Set([
  "REMOVED_SPEAKER",
  "MISSING_DATA",
  "SILENCE",
  UNKNOWN_SPEAKER,
]);

// TODO (ENG-13622): Wrap in t macro
// eslint-disable-next-line lingui/no-unlocalized-strings
const getMultipleSpeakersDisplayName = () => "Multiple Speakers";

export const getSuppressedSpeakerNames = () =>
  new Set([getMultipleSpeakersDisplayName(), UNKNOWN_SPEAKER]);

/* Utils for handling starred transcript entries */
export const prefixStarredTranscriptEntry = (message: string) =>
  `${STARRED_TRANSCRIPT_ENTRY_PREFIX}${message}`;

export const isStarredTranscriptEntry = startsWith(
  STARRED_TRANSCRIPT_ENTRY_PREFIX,
);

export const trimStarredPrefix = (message: string) =>
  message.replace(STARRED_TRANSCRIPT_ENTRY_PREFIX, "");

export const getSpeakerName = (name?: string | null): string | null => {
  if (!name || INVALID_SPEAKER_NAMES.has(name)) return null;

  return name === CROSSTALK ? getMultipleSpeakersDisplayName() : name;
};
